const colleges = {
  all_colleges: 'All Schools',
  create: 'Create new School',
  active: 'Active',
  inactive: 'Inactive',
  detail: 'Detail',
  migrate_period: 'Migrate period',
  disable_college: 'Disable college(s)',
  filters: 'Filters',
  clean_up: 'Clean up',
  search: 'Search',
  status: 'Status',
  state_label: 'State',
  time_zone_label: 'Time zone',
  country: 'Country',
  school_name: 'School name',
  analytics: '📊 Analytics Panel 🎓  ',
  edit: 'Edit',
  general_information: 'General information',
  creation: 'Creation',
  sale: 'Sale',
  commune: 'Commune',
  contact: 'Contact',
  phone: 'Phone',
  current_period_of_operation: 'Current period of operation',
  success_edition_msg: 'The school was successfully edited.',
  error_edition_msg: 'Something went wrong! Try to perform this same action later.',
  students_migrated: 'Students have been migrated',
  massive_load: 'Massive Load',
  massive_load_pending: 'Queued for processing...',
  massive_load_processing: 'Processing upload...',
  massive_load_failed: 'Upload failed.',
  massive_load_completed: 'Upload completed.',
  upload_summary: 'Upload summary',
  upload_summary_sede: 'Campus',
  upload_summary_aula: 'Classroom',
  upload_summary_expected: 'Total in Excel',
  upload_summary_processed: 'Processed',
  upload_summary_not_processed: 'Not processed',
  upload_summary_directives: 'Directives',
  upload_summary_teachers: 'Teachers',
  upload_summary_students: 'Students',
  upload_summary_total: 'Total',
  new_course: 'New course',
  course_saved_success: 'Course saved successfully',
  school_id: 'School ID',
  payment_identifier: 'Payment identifier',
  excel_format: 'Excel Format',
  see_an_example: 'See an example',
  users_have_DNI_label: 'Have users DNI?',
  users_have_DNI_yes: 'Yes',
  users_have_DNI_no: 'No',
  dissable_old_data_label: 'Disable old data?',
  dissable_old_data_yes: 'Yes',
  dissable_old_data_no: 'No',
  file: 'File',
  file_placeholder: 'Choose a file...',
  error_list: 'Error list',
  successful_upload: 'Successful upload!',
  save_as_txt: 'Save as txt',
  massive_load_warning: 'Students that are not in the document will be deactivated.',
  select_group: 'Select school group',
  reports: 'Reports',
  reports_see_column: 'See',
  school_arrangement: 'School Arrangement Details',
  arrangement_name: 'Arrangement name',
  total_licenses: 'Total of licenses',
  arrangement_range_dates: 'Arrangement range dates',
  enrollment_type: 'Arrangement type',
  select_enrollment_type: 'Select an arrangement type',
  create_school_group: 'Create School group',
  school_group: 'School Group',
  select_school_group: 'Select a school group',
  school_arrangement_is_invalid: 'School arrangement data is invalid',
  hide_personal_books: 'Hide personal books',
  disable_autonomous_fluency: 'Disable autonomous fluency recording (students only record with their teacher)',
  calendar_type: 'Calendar Type',
  select_calendar_type: 'Select a calendar type',
  calendar_type_load_error: 'Could not load calendar types. Please try again.',
  academic_periods: 'Academic Periods',
  period_name: 'Period Name',
  start_date: 'Start Date',
  end_date: 'End Date',
  period_type: 'Type',
  default_period: 'Default',
  custom_period: 'Custom',
  create_period: 'Create Period',
  edit_period: 'Edit Period',
  delete_period: 'Delete Period',
  period_created_success: 'Academic period created successfully',
  period_updated_success: 'Academic period updated successfully',
  period_deleted_success: 'Academic period deleted successfully',
  period_error: 'Error managing academic period',
  confirm_delete_period: 'Are you sure you want to delete this period?',
  delete_period_warning: 'This action cannot be undone.',
  validation_start_before_end: 'Start date must be before end date',
  validation_type_a_start: 'For Type A, start date must be between February 1 and April 1',
  validation_type_a_end: 'For Type A, end date must be between November 1 and January 1',
  validation_type_b_start: 'For Type B, start date must be between June 1 and September 1',
  validation_type_b_end: 'For Type B, end date must be between May 1 and July 1',
  validation_type_c_start: 'For Type C, start date must be between April 1 and June 1',
  validation_type_c_end: 'For Type C, end date must be between January 1 and March 1',
  validation_type_start: 'Start date is not within the expected range for this calendar type',
  validation_type_end: 'End date is not within the expected range for this calendar type',
  validation_custom_start: 'Custom period start date must be after {endDate}, the end date of the current default period ({periodName})',
  validation_custom_end: 'Custom period end date must be before next default period start date plus one year',
  validation_overlap: "Dates overlap with period '{periodName}' ({startDate} – {endDate})",
  no_periods_found: 'No academic periods found',
  calendar_type_updated: 'Calendar type updated successfully',
  editing_default_period_info: 'This is a default period linked to a calendar type. Editing its dates automatically redefines the start date of the next academic period of this calendar type.',
  creating_custom_period_info: 'Custom periods can be created between default periods. They will be marked as custom.',
  cannot_delete_default: 'Cannot delete default periods',
  cannot_delete_started: 'Cannot delete a period that has already started',
  edit_started_period: 'Edit Period (already started: name and extension only)',
  edit_ended_period: 'Edit Period (already ended: cannot be edited)',
  start_date_locked_hint: 'This period already started: its start date cannot be changed',
  editing_started_period_info: 'This period has already started. You can rename it and '
    + 'extend its end date, but you cannot move its start date or shorten it.',
  validation_started_period_end: 'This period already started: its end date can only be '
    + 'extended, not brought forward',
  period_ended_alert: 'This academic period has already ended and cannot be edited.',
  agreement_history: 'Agreement History',
  inherited_agreement: 'School Agreement',
  agreement_managed_by_conglomerate: 'This school belongs to a conglomerate. The agreement is managed from the conglomerate.',
  view_conglomerate_agreement: 'View conglomerate agreement',
};

export default colleges;
